import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=24b35a95&scoped=true&"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=24b35a95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b35a95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Volumes/NVME/projects/vbimex/gubuy/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VSelect})
